import randomColor from "randomcolor";
import { Box, Center } from "../../../components/utils";

function Avatar({
  name,
  status,
  isDark,
}: {
  name: string;
  status?: string;
  isDark?: boolean;
}) {
  return (
    <Center className="relative w-9 h-9 loader-linear ">
      <Center
        className={`flex w-9 h-9 rounded-full
         ${isDark ? "bg-gray-100 text-gray-700" : "bg-profileIcon text-white"}
        `}
      >
        <p className="font-bold text-lg ">{name.charAt(0).toUpperCase()}</p>
      </Center>
      {status && status !== "Employed" ? (
        <Box
          className="absolute bottom-0 right-0 flex w-2.5 h-2.5
         bg-red-500 border-2 border-white rounded-full "
        ></Box>
      ) : (
        ""
      )}
    </Center>
  );
}
export default Avatar;
